// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2130":"css/app.6700","8493":"css/admin-app.6700"}[chunkId] + ".css";
};